module.exports = __webpack_public_path__ + "img/gamifinnator-thinker.fa80c7cf.png";